import { IModuleModel } from '../../interface/module/module.model';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace SharedAppActions {
    export class SetApplicationModules {
        public static readonly type = '[SharedApp] SetApplicationModules';
        constructor(public readonly modules: IModuleModel[]) {}
    }

    export class SetAppInitError {
        public static readonly type = '[SharedApp] SetAppInitError';
    }
}
